/**
 * @generated SignedSource<<32996a9a2a05cf4fd9a00cbf71efa063>>
 * @relayHash 1cf5e269ea7ab21dd29830f41cc30471
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 20eef186f5bb28ce94afb25c2e89d7bd8b74a953d39ebd3c1dd60d6420cbf484

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectNotificationConfigurationState = "CONFIGURED" | "DEFAULT" | "%future added value";
export type JiraProjectSortField = "CATEGORY" | "FAVOURITE" | "KEY" | "LAST_ISSUE_UPDATED_TIME" | "LEAD" | "NAME" | "RECOMMENDATION" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraProjectFilterInput = {
  keyword?: string | null | undefined;
  notificationConfigurationState?: JiraProjectNotificationConfigurationState | null | undefined;
  projectCategoryId?: string | null | undefined;
  sortBy?: JiraProjectSortInput | null | undefined;
  types?: ReadonlyArray<JiraProjectType> | null | undefined;
};
export type JiraProjectSortInput = {
  order?: SortDirection | null | undefined;
  sortBy?: JiraProjectSortField | null | undefined;
};
export type ProjectDirectoryLayoutQuery$variables = {
  cloudId: string;
  filter: JiraProjectFilterInput;
  first?: number | null | undefined;
  isAdminSettingsContext: boolean;
  isAnonymous: boolean;
  isRecommendationsEnabled: boolean;
  last?: number | null | undefined;
};
export type ProjectDirectoryLayoutQuery$data = {
  readonly jira: {
    readonly canBrowseProjects: {
      readonly hasPermission: boolean | null | undefined;
    } | null | undefined;
    readonly recommendProjects?: {
      readonly " $fragmentSpreads": FragmentRefs<"RecommendationsList">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"EmptyView" | "Header" | "NoPermissionViews" | "ProjectDirectoryLayout" | "ProjectsList130BadPattern" | "RefinementBar">;
};
export type ProjectDirectoryLayoutQuery = {
  response: ProjectDirectoryLayoutQuery$data;
  variables: ProjectDirectoryLayoutQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider: {
    readonly get: () => boolean;
  };
});

import isAllowingEndUsersToAccessCustomTemplates_provider from '@atlassian/jira-relay-provider/src/jira-custom-template-allow-end-users-to-create-custom-templates.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAdminSettingsContext"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnonymous"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRecommendationsEnabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v7 = [
  {
    "kind": "Variable",
    "name": "isAnonymous",
    "variableName": "isAnonymous"
  }
],
v8 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v9 = {
  "alias": "canBrowseProjects",
  "args": [
    (v8/*: any*/),
    {
      "kind": "Literal",
      "name": "type",
      "value": "BROWSE_PROJECTS"
    }
  ],
  "concreteType": "JiraPermission",
  "kind": "LinkedField",
  "name": "permission",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasPermission"
    }
  ]
},
v10 = [
  {
    "kind": "Literal",
    "name": "activityField",
    "value": "UPDATED"
  },
  (v8/*: any*/),
  {
    "kind": "Literal",
    "name": "days",
    "value": 180
  },
  {
    "kind": "Literal",
    "name": "limit",
    "value": 4
  }
],
v11 = [
  (v8/*: any*/)
],
v12 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = {
  "kind": "ScalarField",
  "name": "name"
},
v15 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v16 = {
  "kind": "ScalarField",
  "name": "key"
},
v17 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "medium"
    }
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "projectStyle"
},
v19 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v20 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v21 = {
  "kind": "ScalarField",
  "name": "totalCount"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectDirectoryLayoutQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "Header"
      },
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "RefinementBar"
      },
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "ProjectsList130BadPattern"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "isAdminSettingsContext",
            "variableName": "isAdminSettingsContext"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ProjectDirectoryLayout"
      },
      {
        "kind": "FragmentSpread",
        "name": "EmptyView"
      },
      {
        "kind": "FragmentSpread",
        "name": "NoPermissionViews"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "condition": "isRecommendationsEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v10/*: any*/),
                "concreteType": "JiraProjectRecommendationConnection",
                "kind": "LinkedField",
                "name": "recommendProjects",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "RecommendationsList"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ProjectDirectoryLayoutQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "canCreateProject",
            "args": [
              (v8/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "CREATE_PROJECT"
              }
            ],
            "kind": "ScalarField",
            "name": "canPerform"
          },
          {
            "args": (v11/*: any*/),
            "concreteType": "JiraWorkManagementLicensing",
            "kind": "LinkedField",
            "name": "jwmLicensing",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "currentUserSeatEdition"
              }
            ]
          },
          {
            "args": [
              (v8/*: any*/),
              {
                "kind": "Variable",
                "name": "filter",
                "variableName": "filter"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "last",
                "variableName": "last"
              }
            ],
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "allJiraProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "canViewIssue",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "VIEW_ISSUES"
                          }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": (v12/*: any*/),
                        "storageKey": "action(type:\"VIEW_ISSUES\")"
                      },
                      (v13/*: any*/),
                      (v14/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                      },
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "navigationMetadata",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "boardId"
                              },
                              (v13/*: any*/)
                            ],
                            "type": "JiraSoftwareProjectNavigationMetadata"
                          }
                        ]
                      },
                      (v20/*: any*/),
                      {
                        "concreteType": "JiraProjectCategory",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lead",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isUser"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "accountId"
                          },
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "picture"
                          },
                          (v13/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectUrl"
                      },
                      {
                        "alias": "canViewProjectConfig",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "VIEW_PROJECT_CONFIG"
                          }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": (v12/*: any*/),
                        "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                      },
                      {
                        "alias": "jiraProjectType",
                        "kind": "ScalarField",
                        "name": "projectType"
                      },
                      {
                        "alias": "jiraProjectName",
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "condition": "isAdminSettingsContext",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": "lastUpdatedToolTipDate",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "format",
                                "value": "COMPLETE_DATETIME_FORMAT"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "lastUpdatedFormatted",
                            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                          },
                          {
                            "alias": "lastUpdatedDisplayDate",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "format",
                                "value": "RELATIVE"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "lastUpdatedFormatted",
                            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v21/*: any*/),
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isHasTotal"
              }
            ]
          },
          {
            "alias": "canContactAdmin",
            "args": [
              (v8/*: any*/),
              {
                "kind": "Literal",
                "name": "keys",
                "value": "jira.show.contact.administrators.form"
              }
            ],
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              {
                "kind": "ScalarField",
                "name": "value"
              },
              (v13/*: any*/)
            ]
          },
          (v9/*: any*/),
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "shouldDisplay",
                "args": [
                  (v8/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_PROJECT_CREATION_ENTRY"
                  }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
              }
            ]
          },
          {
            "condition": "isAnonymous",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v11/*: any*/),
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "projectListRightPanelState"
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ]
              },
              {
                "alias": "sidebarExperimentTemplates",
                "args": [
                  (v8/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "experimentKey",
                    "value": "sidebarExperiment"
                  }
                ],
                "concreteType": "JiraProjectListViewTemplateConnection",
                "kind": "LinkedField",
                "name": "projectListViewTemplates",
                "plural": false,
                "selections": [
                  (v21/*: any*/)
                ]
              },
              {
                "args": (v11/*: any*/),
                "concreteType": "JiraProjectCategoryConnection",
                "kind": "LinkedField",
                "name": "allJiraProjectCategories",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectCategoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isRecommendationsEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v10/*: any*/),
                "concreteType": "JiraProjectRecommendationConnection",
                "kind": "LinkedField",
                "name": "recommendProjects",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectRecommendationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraProjectRecommendation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "details",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "recommendationType"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "inviter",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      (v14/*: any*/),
                                      (v13/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "JiraInviterActivityRecommendation"
                              }
                            ]
                          },
                          {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v13/*: any*/),
                              (v16/*: any*/),
                              (v14/*: any*/),
                              (v18/*: any*/),
                              (v20/*: any*/),
                              (v17/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isAnonymous",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v11/*: any*/),
                "concreteType": "JiraProjectCategoryConnection",
                "kind": "LinkedField",
                "name": "allJiraProjectCategories",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectCategoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "concreteType": "JiraProjectCategory",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v11/*: any*/),
            "concreteType": "JiraProjectTypeDetailsConnection",
            "kind": "LinkedField",
            "name": "allJiraProjectTypes",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectTypeDetailsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProjectTypeDetails",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v13/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "20eef186f5bb28ce94afb25c2e89d7bd8b74a953d39ebd3c1dd60d6420cbf484",
    "metadata": {},
    "name": "ProjectDirectoryLayoutQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider
    }
  }
};
})();

(node as any).hash = "81b049589e01537904d5dc6d16cc10b8";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
